module.exports = __webpack_public_path__ + "img/mimg4.9245af81.png";